import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-backspace-icon',
  templateUrl: './code-backspace.component.html'
})
export class CodeBackspaceComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
